module.exports = require("./../../_gen/starling/assets/BitmapTextureFactory");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/assets/BitmapTextureFactory.js
// module id = 152
// module chunks = 0